import types from "../actionTypes";

export const setOngoingTournamentsModal = (isOpen) => {
  return {
    type: types.SET_ONGOING_TOURNAMENTS_MODAL,
    payload: isOpen,
  };
};